import { InformationQuery, InformationResponse } from '@/api-client/models/buildingScore/Contracts'
import { useFetchGet } from '../../../composables/useFetch'
import { Ref, computed } from 'vue'

export default function useFetchInformation(query: Ref<InformationQuery>) {
  const urlWithParams = computed(() => {
    const urlQuery = encodeURIComponent(JSON.stringify(query.value))
    return `/iot/v1/buildingscore/information?query=${urlQuery}`
  })

  return useFetchGet<InformationResponse>(urlWithParams)
}
